import React, { createContext } from "react";
import { useExpanded, useFilters, useTable } from "react-table";
import { PatientHospitalPresentStratificationTableHead } from "./PatientHospitalPresentStratificationTableHead";
import { PatientHospitalPresentStratificationTableBody } from "./PatientHospitalPresentStratificationTableBody";

export const StratificationTableContext = createContext({});

export const PatientHospitalPresentStratificationTable = ({
  columns,
  data,
  id,
  ...props
}) => {
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns: ["status"],
      },
    },
    useFilters,
    useExpanded,
  );

  const { getTableProps } = tableInstance;

  return (
    <StratificationTableContext.Provider value={{ ...tableInstance }}>
      <table className="myTable stratification-table" {...getTableProps()}>
        <PatientHospitalPresentStratificationTableHead {...props} />
        <PatientHospitalPresentStratificationTableBody id={id} {...props} />
      </table>
    </StratificationTableContext.Provider>
  );
};
